// extracted by mini-css-extract-plugin
module.exports = {"playerName":"ContentCardTitle_playerName__1-LkV"};